import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const AboutSectionContainer = styled(Box)`
  padding: 48px 24px;
  background: #f5f6f7;
  display: flex;
  flex-direction: column;
  gap: 24px;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    flex-direction: row;
  }
  ${({ theme }) => theme.breakpoints.up('md')} {
    gap: 80px;
  }
  ${({ theme }) => theme.breakpoints.up('lg')} {
    padding: 64px 152px;
    margin-top: 130px;
  }
`;

export const ImageWrapper = styled(Box)`
  width: 100%;
  height: 100%;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    max-width: 288px;
    max-height: 317px;
  }
  ${({ theme }) => theme.breakpoints.up('md')} {
    max-width: 384px;
    max-height: 422px;
  }
`;
